import {
  getPutApiV1ThreeLetterCodePartnerAdminsGroupsIdMutationFetcher,
  getPutApiV1ThreeLetterCodePartnerAdminsGroupsIdMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { PutApiV1ThreeLetterCodePartnerAdminsGroupsIdBody } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

/**
 * グループ更新APIを実行するカスタムフック
 *
 * @param threeLetterCode - パートナーコード
 * @param groupId - グループID
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const usePutPartnerAdminsGroup = (
  threeLetterCode: string,
  groupId: number,
  options?: {
    onSuccess?: (data: PutApiV1ThreeLetterCodePartnerAdminsGroupsIdBody) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPutApiV1ThreeLetterCodePartnerAdminsGroupsIdMutationKey(threeLetterCode, groupId),
    getPutApiV1ThreeLetterCodePartnerAdminsGroupsIdMutationFetcher(threeLetterCode, groupId),
    options
  );
};
